import { isChecklistGuest, submitChecklistReview } from "./checklist-api";
import { openChecklistGuestModal } from "./checklist-sidebar";

// Виджет оценки статьи: выбор звёзд → форма отзыва → «Вы уже оценили».
export const initArticleRating = () => {
  const guest = isChecklistGuest();

  document.querySelectorAll<HTMLElement>("[data-rating]").forEach((rating) => {
    // гость: любое взаимодействие (звёзды, отправка, пред/след) открывает модалку
    if (guest) {
      rating.addEventListener("click", (event) => {
        const trigger = (event.target as HTMLElement).closest(
          "[data-rating-star], [data-rating-submit], [data-rating-nav]",
        );

        if (trigger !== null) {
          event.preventDefault();
          openChecklistGuestModal();
        }
      });
      rating.querySelector<HTMLFormElement>("[data-rating-form]")?.addEventListener("submit", (event) => {
        event.preventDefault();
        openChecklistGuestModal();
      });

      return;
    }

    const stars = Array.from(rating.querySelectorAll<HTMLButtonElement>("[data-rating-star]"));
    const starsBox = rating.querySelector<HTMLElement>("[data-stars]");
    const form = rating.querySelector<HTMLFormElement>("[data-rating-form]");

    // сохранённая оценка (режим «уже оценено») — её можно обновить
    let current = Number(rating.dataset.ratingValue) || 0;

    const paint = (value: number) => {
      stars.forEach((star) => {
        star.classList.toggle("is-active", Number(star.dataset.ratingStar) <= value);
      });
    };

    stars.forEach((star) => {
      const value = Number(star.dataset.ratingStar);

      star.addEventListener("mouseenter", () => paint(value));
      star.addEventListener("click", () => {
        current = value;
        rating.classList.add("is-rating");
        paint(current);
      });
    });

    starsBox?.addEventListener("mouseleave", () => paint(current));

    form?.addEventListener("submit", async (event) => {
      event.preventDefault();

      if (current === 0) {
        return;
      }

      const text = form.querySelector<HTMLTextAreaElement>("[data-rating-text]")?.value ?? "";
      const itemId = Number(rating.dataset.itemId);
      const response = await submitChecklistReview(itemId, current, text);

      if (response.success) {
        rating.classList.remove("is-rating");
        rating.classList.add("is-rated");
        paint(current);
      }
    });
  });
};
